export const styles = {
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    left: '0',
    position: 'fixed',
    top: '0',
    width: '100%',
  },
}
